import CONSTANTS from '../../constants';

export function cart(state = [], action) {
  if (action.type === CONSTANTS.ACTIONS.CART.UPDATE) return action.cart;
  return state;
}
